import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
}                 from '@angular/core';
import {
  NG_ASYNC_VALIDATORS,
  NG_VALUE_ACCESSOR,
  Validators,
}                 from '@angular/forms';
import {
  BehaviorSubject,
  takeUntil,
}                 from 'rxjs';
import {
  filterClient,
  SimpleClient,
}                 from '~domain/types';
import { RbForm } from '~shared/directives';

export type SelectClientFormData = {
  clientId: string;
};

@Component({
  selector: 'rb-select-client',
  templateUrl: './select-client.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectClientComponent),
      multi: true,
    },
    {
      provide: NG_ASYNC_VALIDATORS,
      useExisting: forwardRef(() => SelectClientComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class SelectClientComponent extends RbForm implements OnInit, OnChanges {
  @Input({ required: true })
  clients: SimpleClient[] | null = [];

  @Input()
  radioGroupHeight = 'auto';

  override form = this.fb.group({
    clientId: this.fb.control('', [Validators.required]),
  });

  clientsSearch = this.fb.control('');
  filteredClients$ = new BehaviorSubject<SimpleClient[]>([]);

  override ngOnInit() {
    super.ngOnInit();

    this.clientsSearch.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => this.filterClients(value));
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['clients']) {
      this.filterClients(this.clientsSearch.value);
    }
  }

  override writeValue(value: SelectClientFormData) {
    this.form.controls.clientId.setValue(value.clientId);
  }

  private filterClients(search: string) {
    if (!this.clients) {
      return;
    }
    this.filteredClients$.next(this.clients.filter(client => filterClient(client, search.trim().toLowerCase())));
  }
}
